import React from "react";
import { ReportTypeDefinition } from "./types";
import { RaIcon } from "./RaIcon";

interface DataReadyRulesPanelProps {
  reportTypes: ReportTypeDefinition[];
  onClose: () => void;
}

/** Side panel listing when each report's data counts as ready to write. */
export const DataReadyRulesPanel: React.FC<DataReadyRulesPanelProps> = ({
  reportTypes,
  onClose,
}) => (
  <aside className="hist open" aria-label="Data-ready rules">
    <div className="hh">
      <div>
        <b>Data-ready rules</b>
        <span>When each report’s data counts as ready to write</span>
      </div>
      <button type="button" className="ib" aria-label="Close" onClick={onClose}>
        <RaIcon name="x" />
      </button>
    </div>
    <div className="hlist">
      {reportTypes.map((t) => (
        <div key={t.key} className="rl">
          <b>{t.name}</b>
          <span>{t.dataReadyCriterion}</span>
        </div>
      ))}
    </div>
    <div className="sfoot">
      <RaIcon name="gear" />
      <span>Set once per report type and applied to every project automatically.</span>
    </div>
  </aside>
);
